<template>
  <Popup
    :show="props.modelValue"
    :close-on-click-overlay="props.closable"
    @close="handleClose"
    class="dialog"
    :style="{backgroundColor: 'transparent'}"
  >
    <div class="outer">
      <div class="inner">
        <div class="wrap">
          <slot name="title" v-if="props.title">
            <div class="title">
              <span class="title-text">
                {{ props.title }}
              </span>
            </div>
          </slot>
          <div class="content">
            <slot></slot>
          </div>
        </div>
      </div>
      <img
        v-if="props.closable"
        src="@/views/act/monopoly/assets/img/close.png"
        alt="close"
        class="close-btn"
        @click="handleClose"
      >
    </div>
  </Popup>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { Popup } from 'vant'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  closable: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const handleClose = () => {
  if (!props.closable) return
  emit('update:modelValue', false)
}
</script>

<style scoped lang="less">
.outer {
  background: rgba(255, 255, 255, 0.5);
  width: 718px;
  padding: 6px;
  border-radius: 6px;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  position: relative;
  .inner {
    background: #9FF7FD;
    padding: 6px;
    border-top-left-radius: 44px;
    border-bottom-right-radius: 44px;
    .wrap {
      background-image: linear-gradient(to bottom, #B2F8FC, #ECFDFF);
      border-top-left-radius: 38px;
      border-bottom-right-radius: 38px;
      .title {
        border-top-left-radius: 38px;
        background: #23AFFC;
        font-size: 0;
        min-height: 66px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        .title-text {
          display: inline-block;
          width: 550px;
          font-weight: bold;
          font-size: 36px;
          line-height: 1.2;
          color: #FFFFFF;
          text-align: center;
          
        }
        
      }
      .content {
        min-height: 300px;
        max-height: calc(85vh - 120px);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        display: flex;
        flex-direction: column;
        align-items: center;
        // 短内容靠子元素 margin:auto 居中；长内容可完整滚动（避免 center + overflow 裁切）
        justify-content: flex-start;
        padding: 24px 28px 48px;
        box-sizing: border-box;

        > :deep(*) {
          margin-top: auto;
          margin-bottom: auto;
          flex-shrink: 0;
        }
      }
    }
  }
  .close-btn {
    height: 36px;
    position: absolute;
    right: 17px;
    top: 25px;
    cursor: pointer;
  }
}
</style>